import { Navigate } from 'react-router-dom'
import { Alert, Spinner, Typography } from '@material-tailwind/react'
import { Trans, useTranslation } from 'react-i18next'
import { useBucketInfo } from '../hooks/useBucketInfo'
import { usePageTitle } from '../hooks/toolkit'
import { AGAMI_INDOOR_BUCKET } from '../utils/constants/db.constants'
import AgamiIndoorConfigEditor from '../components/AgamiIndoorConfigEditor'
import AgamiIndoorAudioFilesManager from '../components/AgamiIndoorAudioFilesManager'
import { useFeatureFlag } from '../hooks/authorization'
import { FEATURE_FLAGS } from '../utils/constants/features.constants'
import { useDarkMode } from '../contexts/DarkModeContext'

const DashboardAgamiIndoor = () => {
  const { t } = useTranslation()
  usePageTitle(t('dashboardAgamiIndoor.pageTitle'))
  const agamiIndoorFlag = useFeatureFlag(FEATURE_FLAGS.AGAMI_INDOOR)
  const { darkMode } = useDarkMode()
  const {
    isLoading: bucketLoading,
    uploadSizeLimit,
    allowedFileTypes,
  } = useBucketInfo({ bucket: AGAMI_INDOOR_BUCKET })

  if (!agamiIndoorFlag) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="w-full flex flex-col py-4 gap-y-4">
      {bucketLoading && (
        <div className="w-full my-10">
          <Spinner className="h-12 w-12 mx-auto" />
        </div>
      )}

      {!bucketLoading && (
        <>
          <div className="flex flex-col lg:max-w-[80%] gap-y-4">
            <Typography variant="h1" className="text-2xl md:text-5xl">
              {t('dashboardAgamiIndoor.title')}
            </Typography>
            <Alert variant={darkMode ? 'filled' : 'ghost'} color="blue" className="w-full mt-1">
              <Trans
                i18nKey="dashboardAgamiIndoor.experimentalFeature"
                components={{
                  em: <em />,
                  strong: <strong />,
                }}
              />
              <Typography className="dark:text-base-gray-400">
                {t('dashboardAgamiIndoor.hereYouCan')}
              </Typography>
              <ul className="list-disc list-inside space-y-1 px-2 pb-2">
                <li>
                  <Trans
                    i18nKey="dashboardAgamiIndoor.defineExperienceConfig"
                    components={{
                      em: <em />,
                      strong: <strong />,
                    }}
                  />
                </li>
                <li>
                  <Trans
                    i18nKey="dashboardAgamiIndoor.uploadAudioFiles"
                    components={{
                      em: <em />,
                      strong: <strong />,
                    }}
                  />
                </li>
              </ul>
              <Trans
                i18nKey="dashboardAgamiIndoor.onceConfigured"
                components={{
                  em: <em />,
                  strong: <strong />,
                }}
              />
            </Alert>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            <AgamiIndoorConfigEditor />
            <AgamiIndoorAudioFilesManager
              uploadSizeLimit={uploadSizeLimit}
              allowedFileTypes={allowedFileTypes}
            />
          </div>
        </>
      )}
    </div>
  )
}

export default DashboardAgamiIndoor
